import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { iconMarkup } from '../icons/index.js';
import { go, openAddRecipient, openEditRecipient, deleteRecipient } from '../actions.js';

function recipientRow(r) {
  return h('div', { class: 'card' }, [
    h('div', { class: 'row-top' }, [
      h('div', {}, [
        h('div', { class: 'name' }, r.name),
        h('div', { class: 'mono text-sm text-muted' }, r.address)
      ]),
      h('div', { class: 'flex-gap-sm' }, [
        h('button', { class: 'icon-btn', 'aria-label': `Edit ${r.name}`, onclick: () => openEditRecipient(r.id) },
          h('span', { html: iconMarkup('pencil', { size: 14 }) })),
        h('button', { class: 'icon-btn', 'aria-label': `Delete ${r.name}`, onclick: () => deleteRecipient(r.id) },
          h('span', { html: iconMarkup('trash', { size: 14 }) }))
      ])
    ])
  ]);
}

export function renderRecipients() {
  const s = getState();
  const rows = s.savedRecipients.map(recipientRow);

  return h('div', { class: 'screen' }, [
    h('button', { class: 'icon-btn mb-sm', onclick: () => go('move') }, [
      h('span', { html: iconMarkup('arrowLeft', { size: 16 }) }), ' Back'
    ]),
    h('div', { class: 'flex-between' }, [
      h('h1', { class: 'screen-title' }, 'Recipients'),
      h('button', { class: 'btn btn-primary btn-sm', onclick: openAddRecipient }, '+ Add')
    ]),
    rows.length
      ? h('div', { class: 'stack' }, rows)
      : h('div', { class: 'empty-state' }, 'No saved recipients yet. Add one from here or from the Send screen.')
  ]);
}
